import React, { useState, useEffect } from 'react';

import { useBreadcrumbs } from '../../hooks';
import { useLeagues } from './useLeagues';
import { useSeasons } from './useSeasons';
import { usePaginatedTeams } from './usePaginatedTeams';
import TeamSelection from './TeamSelection';
import { useProfile } from '../shared/hooks';

const createBreadcrumbs = () => [{ title: 'Teams' }];

const TeamSelectionPage = () => {
  useBreadcrumbs(createBreadcrumbs, []);

  // profile
  const profile = useProfile();

  // leagues
  const leagues = useLeagues(profile);
  const [league, setLeague] = useState();
  useEffect(() => {
    if (leagues && leagues.length) setLeague(leagues[0]);
    else setLeague(undefined);
  }, [leagues, profile]);
  const handleLeagueChange = id => {
    id = +id;
    const league = leagues.find(l => l.id === id);
    if (league) setLeague(league);
  };

  // seasons
  const seasons = useSeasons(league);
  const [season, setSeason] = useState();
  useEffect(() => {
    if (seasons && seasons.length) setSeason(seasons[0]);
    else setSeason(undefined);
  }, [seasons]);
  const handleSeasonChange = id => {
    id = +id;
    const season = seasons.find(l => l.id === id);
    if (season) setSeason(season);
  };

  const [teamName, setTeamName] = useState();
  useEffect(() => {
    setTeamName(teamName);
  }, [teamName]);
  const handleTeamNameChange = teamName => {
    setTeamName(teamName);
  };

  // teams
  const teamsPageSize = 30;
  const [teamsCurrentPage, setTeamsCurrentPage] = useState(0);
  const { teamsCount, teams } = usePaginatedTeams(
    league,
    season,
    teamName,
    teamsCurrentPage,
    teamsPageSize,
  );

  return (
    <TeamSelection
      league={league}
      leagues={leagues}
      onLeagueChange={handleLeagueChange}
      onSeasonChange={handleSeasonChange}
      onTeamNameChange={handleTeamNameChange}
      season={season}
      seasons={seasons}
      teamName={teamName}
      teams={teams}
      teamsCount={teamsCount}
      teamsCurrentPage={teamsCurrentPage}
      teamsPageSize={teamsPageSize}
      onPageChange={setTeamsCurrentPage}
    />
  );
};

export default TeamSelectionPage;
